var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.jobs),function(job){return _c('div',[_c('a',{on:{"click":function($event){return _vm.selectJob(job)}}},[_c('strong',[_vm._v(_vm._s(job.title))])]),_c('div',[_vm._v("\n      "+_vm._s(job.short)+"\n    ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }